// Shared Scenario type used by every fixture file.
// See plans/saas-billing/01-stripe-billing-foundation.md.

import {
  AICreditBalance,
  ConsumptionEvent,
  FeatureUsageBreakdown,
  Invoice,
  PaymentMethod,
  Plan,
  Receipt,
  Subscription,
  TopUpHistoryEntry,
  TopUpPack
} from '../../../models/billing';
import { ScenarioName } from '../billing-mock.interface';

export interface Scenario {
  name: ScenarioName;
  // Null for `new_signup_incomplete` only.
  subscription: Subscription | null;
  plans: Plan[];
  invoices: Invoice[];
  receipts: Receipt[];
  paymentMethod: PaymentMethod | null;
  // Null for `new_signup_incomplete` only (no wallet without a subscription).
  aiCreditBalance: AICreditBalance | null;
  topUpPacks: TopUpPack[];
  // Count of currently-active users on the tenant. Drives the
  // SEATS_BELOW_ACTIVE_USERS warning in the change-plan flow (#04). Optional
  // for back-compat; falls back to `subscription.seats` when absent (i.e. no
  // warning unless newSeats < activeUsers).
  activeUserCount?: number;
  // ---- AI credit usage data for the detail page (#08) ---------------------
  // Optional so existing fixtures need not declare all three when there is no
  // wallet (e.g., `new_signup_incomplete`). When omitted, the mock returns
  // empty arrays.
  consumptionEvents?: ConsumptionEvent[];
  featureUsageBreakdown?: FeatureUsageBreakdown[];
  topUpHistory?: TopUpHistoryEntry[];
}

// Shared deterministic IDs across fixtures - useful for tests.
export const TENANT_ID_DEFAULT = '11111111-1111-1111-1111-111111111111';
export const TENANT_ID_NG = '22222222-2222-2222-2222-222222222222';
export const TENANT_ID_GB = '33333333-3333-3333-3333-333333333333';
export const TENANT_ID_DE = '44444444-4444-4444-4444-444444444444';

// Time helpers - computed at call time (not module load) so relative-time
// fixtures stay accurate across long dev sessions and tests that run minutes
// after module init. Each call returns a fresh ISO timestamp relative to now.
export function daysFromNow(days: number): string {
  const d = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
  return d.toISOString();
}

export function hoursFromNow(hours: number): string {
  const d = new Date(Date.now() + hours * 60 * 60 * 1000);
  return d.toISOString();
}
